import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    margin: '10px 0',
  },
  news: {
    backgroundColor: '#FAAD14 ',
    fontSize: 11,
    padding: '1px 8px',
    borderRadius: 16,
    marginLeft: 8,
  },
}));
